







import { Component, Vue, Prop, Model } from 'vue-property-decorator';

@Component
export default class BaseTextInput extends Vue {
  @Model('input', { type: String }) private value!: string;
  @Prop({ default: '', type: String }) private title!: string;
}
